import styled, { css } from 'styled-components';
import { Title } from '@trevor/ui-components';

export const ScrollContainer = styled.div`
  max-height: 434px;
  overflow: auto;
`;

export const SavedQueriesList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const SavedQueriesItem = styled.li<{ $selected: boolean }>`
  cursor: pointer;
  display: flex;
  padding: 10px;
  border-bottom: 1px solid #ccc;

  &:hover {
    background-color: #f8f8f8;
  }

  &:last-child {
    border-bottom: none;
  }

  ${Title} {
    margin-bottom: 8px;
  }

  ${(p) =>
    p.$selected &&
    css`
      background-color: #eae3fc;

      &:hover {
        background-color: #e6dffa;
      }
    `}
`;

export const FilterBar = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 6px;
  padding-block: 10px;
`;

export const SearchTermContainer = styled.div`
  display: flex;
  flex-grow: 1;
`;

export const SearchControlsContainer = styled.div`
  display: flex;

  & > div {
    margin-left: 16px;
  }
`;

export const SearchTermInput = styled.input`
  border: none;
  flex-grow: 1;
  margin-left: 15px;
`;

export const FilterButton = styled.button<{ $active?: boolean }>`
  background-color: #fff;
  border: none;
  border-radius: 4px;
  color: #061e2d;
  font-size: 12px;
  line-height: 18px;
  padding: 8px;

  ${(p) =>
    p.$active &&
    css`
      background-color: #eee;
      color: #333;
    `}
`;

export const SelectedCategory = styled.div`
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  padding: 7px 8px;

  span {
    color: #061e2d;
    font-size: 12px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 80px;
  }

  svg {
    margin-left: 2px;
  }
`;

export const CategoryList = styled.div`
  --border-radius: 4px;

  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: var(--border-radius);
  box-shadow: 0 9px 13px 7px rgba(0, 0, 0, 0.2);
  max-height: 370px;
  overflow: auto;
  width: 190px;
`;
